/**
 * Aurora Photo Wall — Justified Masonry
 * Reads each image's natural aspect ratio and applies it to the grid item,
 * enabling CSS flexbox to create a justified gallery layout.
 * Works with lazy loading, AJAX filtering, and pagination.
 *
 * Uses polling (requestAnimationFrame) to catch lazy-loaded images as they
 * appear on scroll, since load event listeners aren't reliable for
 * images with loading="lazy".
 */
(function () {
  var GRID_IDS = ['product-grid', 'more-collection-grid'];
  var POLL_MS = 300;
  var PORTRAIT_BOOST = 1.0; // 1.0 = no boost (adjust to increase portrait size)
  var pollTimer = null;

  function processGrid() {
    var pending = 0;
    for (var g = 0; g < GRID_IDS.length; g++) {
      var grid = document.getElementById(GRID_IDS[g]);
      if (!grid) continue;
      pending += processOneGrid(grid);
    }
    return pending;
  }

  function processOneGrid(grid) {
    var pending = 0;
    var items = grid.querySelectorAll('.grid__item');

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      // Skip already processed
      if (item.getAttribute('data-ar-set')) continue;

      var img = item.querySelector('img');
      if (!img) continue;

      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        var ar = img.naturalWidth / img.naturalHeight;
        var fg = ar < 1 ? ar * PORTRAIT_BOOST : ar;
        item.style.setProperty('--aspect-ratio', ar.toFixed(4));
        item.style.setProperty('--flex-grow', fg.toFixed(4));
        item.setAttribute('data-ar-set', '1');
      } else {
        pending++;
      }
    }

    return pending;
  } // end processOneGrid

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      var pending = processGrid();
      if (pending === 0) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, POLL_MS);
  }

  // Initial run + start polling for lazy images
  function init() {
    var pending = processGrid();
    if (pending > 0) startPolling();
  }

  // Run on ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when AJAX filtering replaces the grid (Dawn's facets.js)
  var container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          // Reset processed flags and re-scan
          init();
          break;
        }
      }
    }).observe(container, { childList: true, subtree: true });
  }
})();
